import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAppApiUrl } from '@api/services/client.service';
import { getApiUrl, setApiUrl, setProxyUrl, setSocketUrl } from 'httpConfig/api-url';

const useAppApiUrlData = () => {
    const [isLoading, setIsLoading] = useState(true);

    const { data, error, isFetching } = useQuery(['appApiUrl'], () => getAppApiUrl(window.location.host));

    useEffect(() => {
        const apiUrl = getApiUrl();

        // Case 1: already configured locally
        if (apiUrl) {
            setIsLoading(false);
            return;
        }

        // Case 2: data arrived from server
        if (data?.url) {
            const url = data.url;
            setApiUrl(`${url}/api/v4`);
            setSocketUrl(url);
            setProxyUrl(`${url}/proxy`);
            setIsLoading(false);
        }

        // Case 3: error case
        if (error && !isFetching) {
            setIsLoading(false);
        }
    }, [data, error, isFetching]);

    return {
        isLoading,
        isError: !!error,
    };
};

export default useAppApiUrlData;
